export enum WagonIndexEnum {
  'ska1'= 0,
  'oa1'= 1,
  'oa2'= 2,
  'oa3'= 3,
  'ska2'= 4
}
